<template>
    <v-container class="input-text-size">
      <WarrantsTransactionCriteria
      @loadCRUDList="getApportionmentWarrantsRecord"
      :baseCrudKey="baseCrudKey"/>
      <CRUDList
            ref="crudList"
            :canAdd="true"
            :headers='headers'
            :displayTopPagination="false"
            :canEdit="true"
            :canSave="false"
            :showDate="false"
            :showTotal="true"
            :enableFixedHeaders="true"
            :dialogHeaderName="dialogHeaderName"
            @loadCRUDList="getApportionmentWarrantsRecord"
            :baseCrudKey="baseCrudKey"
            tableWrapperDynamicClassname='elevation-3 ma-3 pa-3 taxroll-table-wrapper'
            tableDynamicClassname='taxroll-custom-table'
            tableDynamicHeight='350'
            :loadingData="gridLoading.flag"
            :loadingText="gridLoading.text"
            dialogDynamicWidth="500"
           >
           <template v-slot:[`editedItem`]="{}">
        <remitWarrantEditDialog
        :baseCrudKey="baseCrudKey"
        />
      </template>
        </CRUDList>
                <div class="flex-btns input-text-size">
                  <div>
                    <v-row class="mt-2">
                    <v-col class="ml-4">
                      <v-btn
                        color="primary"
                        small
                        rounded
                        @click="printWarrantRegister"
                      >
                        Warrant Register
                      </v-btn>
                    </v-col>
                      <v-col class="ml-7">
                      <v-btn
                        color="primary"
                        small
                        rounded
                        @click="printCopyOfWarrantsReport"
                      >
                        Copy of Warrants
                      </v-btn>
                    </v-col>
                    <v-col class="ml-6">
                      <v-btn
                        color="primary"
                        small
                        rounded
                        @click="printWarrantsReport"
                      >
                        Actual Warrants
                      </v-btn>
                    </v-col>
                    <v-col class="ml-6">
                      <v-btn color="primary"
                      :disabled="createWarrantsDisable || creatingWarrants"
                      :loading="creatingWarrants"
                      small rounded @click="openDialogForDate">
                        POST TO WARRANT REGISTER
                      </v-btn>
                    </v-col>
                    <v-col class="ml-6">
                      <v-btn color="primary" small rounded @click="openDailogEftAch">
                        Create ACH File
                      </v-btn>
                    </v-col>
                    <v-col class="ml-6">
                      <v-btn
                        color="primary"
                        small
                        rounded
                        @click="printEftAchReport"
                      >
                        EFT/ACH Report
                      </v-btn>
                    </v-col>
                    </v-row>
                    <v-row>
                    <v-col cols="2" class="ml-6">
                      <v-btn
                        color="primary"
                        small
                        rounded
                        @click="showEmailConfirmationDialog"
                      >
                        Send Warrant Email
                      </v-btn>
                    </v-col>
                    <v-col cols="2" class="ml-2">
                      <v-btn
                        color="primary"
                        small
                        rounded
                        @click="printRemitEnvelops"
                      >
                        Print Envelopes
                      </v-btn>
                    </v-col>
                    </v-row>
                  </div>
                </div>
      <v-dialog v-model="openCreateWarrantsDialog" max-width="420" class="input-text-size">
      <v-card>
        <v-card-title class="input-text-size">Replace Records?</v-card-title>
        <v-card-text class="input-text-size" >
          <v-container>
          <v-row dense  hide-details>
          <span>Warrants for the Apportionment dates {{ axFromDate }} to {{ axToDate }}</span>
          <span>have already been created. </span>
          <span>Do you wish to replace those warrants records?</span>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions class="input-text-size">
          <v-btn color="primary" small :disabled="creatingWarrants"
            :loading="creatingWarrants" @click="replaceWarrants"
            >Continue</v-btn
          >
          <v-btn small :disabled="creatingWarrants" @click="closeGLDialog">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="openDailog" max-width="420" class="input-text-size">
      <v-card>
        <v-card-text class="input-text-size" >
          <v-container>
          <v-row dense  hide-details>
            <ClarionDateControl class=""
                    :isRequired="false" :isToggle="false"
                    label="Effective Date"
                    v-model="effectiveDateVal"
                     />
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions class="input-text-size">
          <v-btn color="primary" small @click="achExport"
            >Ok</v-btn
          >
          <v-btn small @click="closeGLDialogEftAch">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog max-width="400" v-model="openEmailConfirmationDialog">
      <v-card>
        <v-card-title class="input-text-size">
          Confirm Email Send
        </v-card-title>
        <v-card-text>
          <v-container>
          <v-row dense  hide-details>
          <span>This will send an email to every remit unit containing
            their {{ this.criteriaState.remitWarrantDate }} warrant.</span>
          <span>Do you want to continue?</span>
          </v-row>
        </v-container>
          <v-btn
            color="blue darken-1"
            text
            class="input-text-size"
            :loading="isSendingEmails"
            :disabled="isSendingEmails"
            @click="emailEftAchReport()"
          >
            Continue
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            class="input-text-size"
            :disabled="isSendingEmails"
            @click="closeDialog()"
          >
            Cancel
          </v-btn>
        </v-card-text>
    </v-card>
    </v-dialog>
     <v-dialog v-model="openCreateWarrantDialog" max-width="350">
      <v-card>
        <v-card-title class="">EFT Warrant records found</v-card-title>
        <v-card-text class="input-text-size" >
          <p>Please Provide the date for which these EFT
            warrant records should be show as "Paid"</p>
          <v-container>
          <v-row dense  hide-details>
            <v-col cols="8">
              <ClarionDateControl class="input-text-size"
                  label="Paid Date" :isRequired="false" :isToggle="false"
                  v-model="criteriaState.paidDate"/>
            </v-col>
            </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions class="input-text-size">
          <v-btn color="primary" small :disabled="creatingWarrants"
            :loading="creatingWarrants" @click="createActualWarrants"
            >Ok</v-btn
          >
          <v-btn small :disabled="creatingWarrants" @click="closeGLDialogWarrants">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </v-container>
</template>

<script>
import {
  mapGetters, mapMutations, mapActions, mapState,
} from 'vuex';
import CRUDList from '../common/base/crud-2.0/CRUDList.vue';
import { warrantsTransactionListHeaders } from './apportionmentutils/apportionmentTableHeader';
import '../../assets/style.css';
import { defaultGridLoading, manageGridLoading } from '../../util/shared/vue-global';
import WarrantsTransactionCriteria from './RemitWarrantsTransactionCriteria..vue';
import { generateQueryString } from '../common/base/report/report-util';
import { clients } from '../../util/clients';
import remitWarrantEditDialog from './remitWarrantEditDialog.vue';
import { toIsoDate } from '../../util/shared/tmc-global';
import ClarionDateControl from '../common/ClarionDateControl.vue';

const { backendRest } = clients.direct;

export default {
  name: 'apportionment',
  data() {
    return {
      headers: warrantsTransactionListHeaders,
      gridLoading: defaultGridLoading(),
      dialogHeaderName: 'Remit Warrant Detail',
      baseCrudKey: 'remitWarrantsCrudKey',
      openCreateWarrantsDialog: false,
      axFromDate: '',
      axToDate: '',
      createWarrantsDisable: false,
      // True from the click until the response comes back; a second request for the same
      // date would create the warrants twice.
      creatingWarrants: false,
      isSendingEmails: false,
      effectiveDateVal: null,
      openDailog: false,
      openEmailConfirmationDialog: false,
      openCreateWarrantDialog: false,
      remitUnitsCrudKey: 'remitWarrantsRemitUnitsCrudKey',
      // Separate from the grid's key so the pre-post check never replaces what the grid shows.
      postCheckCrudKey: 'remitWarrantsPostCheckCrudKey',
    };
  },
  components: {
    CRUDList,
    WarrantsTransactionCriteria,
    remitWarrantEditDialog,
    ClarionDateControl,
  },
  computed: {
    ...mapGetters('base/crud', ['criteria', 'item', 'items']),
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
    ...mapState({
      storeSelItems:
      (state) => state.apportionment.apportionmentRemitWarrants.selectedItems || [],
    }),
    selectedItems: {
      get() {
        return this.storeSelItems;
      },
      set(value) {
        this.setSelectedItems(value);
      },
    },
  },
  methods: {
    ...mapActions(['reAuth', 'flashError', 'flashWarn']),
    ...mapMutations('base/crud', [
      'setCriteria',
    ]),
    ...mapActions('config', [
      'loadTransformMappers',
    ]),
    manageGridLoading,
    ...mapMutations('apportionment/apportionmentRemitWarrants', [
      'setSelectedItems',
    ]),
    ...mapActions('apportionment/apportionmentRemitWarrants', [
      'loadApportionmentRemitWarrantsRecords',
      'buildActualWarrantsRecord',
    ]),
    ...mapActions('shared/remitUnit', [
      'loadremitUnitRecords',
    ]),
    async openDialogForDate() {
      const warrantItems = this.items(this.baseCrudKey) || [];
      const remitUnitCodes = [
        ...new Set(warrantItems.map((el) => el.remitUnit).filter(Boolean)),
      ];
      if (this.creatingWarrants) {
        return;
      }
      // Lock while the remit units load too, so a double click can't start two checks.
      this.creatingWarrants = true;
      try {
        await this.loadremitUnitRecords({
          criteria: {},
          baseCrudKey: this.remitUnitsCrudKey,
        });
      } finally {
        this.creatingWarrants = false;
      }
      const remitUnitsList = this.items(this.remitUnitsCrudKey) || [];
      const hasEftRemitUnit = remitUnitsList.some(
        (ru) => remitUnitCodes.includes(ru.remitUnit) && ru.achEft,
      );
      if (hasEftRemitUnit) {
        this.openCreateWarrantDialog = true;
        this.$set(this.criteriaState, 'paidDate', this.criteriaState.remitWarrantDate);
      } else {
        this.createActualWarrants();
      }
    },
    closeGLDialogWarrants() {
      this.openCreateWarrantDialog = false;
    },
    async getApportionmentWarrantsRecord() {
      const { baseCrudKey } = this;
      if (this.criteriaState.remitWarrantDate) {
        this.criteriaState.remitWarrantDate = toIsoDate(this.criteriaState.remitWarrantDate);
      }
      // this.criteriaState.remitWarrantDate = toIsoDate(this.criteriaState.remitWarrantDate);
      const criteria = {
        ...this.criteriaState,
      };
      delete criteria.toDate;
      delete criteria.fromDate;
      delete criteria.fromDateValue;
      delete criteria.toDateValue;
      delete criteria.fromBusinessDateValue;
      delete criteria.toBusinessDateValue;
      delete criteria.paidDate;
      // manageGridLoading(this, true, 'Searching...');
      await this.loadApportionmentRemitWarrantsRecords({ criteria, baseCrudKey })
        .then((res) => {
          const filterRes = res.filter((el) => el.isLocked);
          if (filterRes.length && this.criteriaState.remitWarrantDate) {
            this.createWarrantsDisable = true;
          } else {
            this.createWarrantsDisable = false;
          }
        });
      // .finally(() => {
      //   manageGridLoading(this, false);
      // });
    },
    emitSelectedItem(id) {
      this.selectedItems = id;
    },
    async createActualWarrants() {
      if (this.creatingWarrants) {
        return;
      }
      const cri = {
        ...this.criteriaState,
      };
      const ConPaidDate = toIsoDate(cri.paidDate);
      const criteria = {
        ...cri,
        paidDate: ConPaidDate,
      };
      delete criteria.toDate;
      delete criteria.fromDate;
      delete criteria.fromDateValue;
      delete criteria.toDateValue;
      if (!criteria.remitWarrantDate) {
        this.flashWarn('Please select Warrant Date!');
        return;
      }
      this.creatingWarrants = true;
      try {
        // Ask the server rather than the grid, which may be filtered to one unit or loaded
        // before someone else posted this date.
        const rowsForDate = await this.loadApportionmentRemitWarrantsRecords({
          criteria: { remitWarrantDate: criteria.remitWarrantDate },
          baseCrudKey: this.postCheckCrudKey,
        });
        const warrantsCreated = (rowsForDate || []).filter((el) => el.warrantsCreated === true);
        if (warrantsCreated.length > 0) {
          this.axFromDate = warrantsCreated[0].axFromDate;
          this.axToDate = warrantsCreated[0].axToDate;
          this.openCreateWarrantsDialog = true;
        } else {
          await this.buildActualWarrantsRecord({ criteria });
          this.getApportionmentWarrantsRecord();
          this.openCreateWarrantDialog = false;
        }
      } finally {
        this.creatingWarrants = false;
      }
    },
    async replaceWarrants() {
      if (this.creatingWarrants) {
        return;
      }
      const cri = {
        ...this.criteriaState,
      };
      const convPaidDate = toIsoDate(cri.paidDate);
      const criteria = {
        ...cri,
        paidDate: convPaidDate,
      };
      this.creatingWarrants = true;
      try {
        await this.buildActualWarrantsRecord({ criteria });
        this.getApportionmentWarrantsRecord();
        this.openCreateWarrantsDialog = false;
      } finally {
        this.creatingWarrants = false;
      }
    },
    closeGLDialog() {
      this.openCreateWarrantsDialog = false;
    },
    closeGLDialogEftAch() {
      this.openDailog = false;
    },
    openDailogEftAch() {
      const storedEffectiveDate = localStorage.getItem('effectiveDate');
      if (storedEffectiveDate) {
        this.effectiveDateVal = storedEffectiveDate;
      }
      this.openDailog = true;
    },
    async printWarrantRegister() {
      const { jwt } = await this.reAuth();
      const getcriteria = {
        ...this.criteriaState,
      };
      const encodedCriteria = encodeURIComponent(JSON.stringify(getcriteria));
      const params = [
        `token=${jwt}`,
        `filters=${encodedCriteria}`,
      ];
      if (this.devSetting && this.devSetting.isTestEnvironment) {
        params.push('isTestCafe=1');
      }
      const queryString = generateQueryString(params);
      const url = `${backendRest.defaults.baseURL}/remit/warrant-register-summary${queryString}`;
      window.open(url, '_blank');
    },
    async printCopyOfWarrantsReport() {
      const { jwt } = await this.reAuth();
      const getcriteria = {
        ...this.criteriaState,
      };
      const encodedCriteria = encodeURIComponent(JSON.stringify(getcriteria));
      if (this.criteriaState.remitWarrantDate) {
        const params = [
          `token=${jwt}`,
          `filters=${encodedCriteria}`,
        ];
        params.push('isActual=false');
        if (this.devSetting && this.devSetting.isTestEnvironment) {
          params.push('isTestCafe=1');
        }
        const queryString = generateQueryString(params);
        const url = `${backendRest.defaults.baseURL}/remit/copy-of-warrants${queryString}`;
        window.open(url, '_blank');
      } else {
        this.flashWarn('Please select warrant date to print Copy of Warrants!');
      }
    },
    async printWarrantsReport() {
      const { jwt } = await this.reAuth();
      const getcriteria = {
        ...this.criteriaState,
      };
      const encodedCriteria = encodeURIComponent(JSON.stringify(getcriteria));
      if (this.criteriaState.remitWarrantDate) {
        const params = [
          `token=${jwt}`,
          `filters=${encodedCriteria}`,
        ];
        params.push('isActual=true');
        if (this.devSetting && this.devSetting.isTestEnvironment) {
          params.push('isTestCafe=1');
        }
        const queryString = generateQueryString(params);
        const url = `${backendRest.defaults.baseURL}/remit/copy-of-warrants${queryString}`;
        window.open(url, '_blank');
      } else {
        this.flashWarn('Please select warrant date to print Actual Warrants!');
      }
    },
    showEmailConfirmationDialog() {
      if (!this.isFiltersAvailable()) {
        this.flashWarn('Please select warrant date to send Warrant Email!');
        return;
      }
      this.openEmailConfirmationDialog = true;
    },
    async emailEftAchReport() {
      // A closed dialog means the emails were already sent (it closes with its leave animation).
      if (this.isSendingEmails || !this.openEmailConfirmationDialog) {
        return;
      }
      this.isSendingEmails = true;
      try {
        const { jwt } = await this.reAuth();
        const getcriteria = {
          ...this.criteriaState,
        };
        const encodedCriteria = encodeURIComponent(JSON.stringify(getcriteria));
        const params = [
          `token=${jwt}`,
          `filters=${encodedCriteria}`,
        ];
        if (this.devSetting && this.devSetting.isTestEnvironment) {
          params.push('isTestCafe=1');
        }
        const queryString = generateQueryString(params);
        const url = `${backendRest.defaults.baseURL}/remit/email-eft-ach-summary${queryString}`;
        window.open(url, '_blank');
      } finally {
        this.isSendingEmails = false;
        this.openEmailConfirmationDialog = false;
      }
    },
    closeDialog() {
      this.openEmailConfirmationDialog = false;
    },
    async printRemitEnvelops() {
      const { jwt } = await this.reAuth();
      const getcriteria = {
        ...this.criteriaState,
      };
      const encodedCriteria = encodeURIComponent(JSON.stringify(getcriteria));
      if (this.criteriaState.remitWarrantDate) {
        const params = [
          `token=${jwt}`,
          `filters=${encodedCriteria}`,
        ];
        if (this.devSetting && this.devSetting.isTestEnvironment) {
          params.push('isTestCafe=1');
        }
        const queryString = generateQueryString(params);
        const url = `${backendRest.defaults.baseURL}/remit/print-remit-envelopes${queryString}`;
        window.open(url, '_blank');
      } else {
        this.flashWarn('Please select warrant date to print EFT/ACH Report!');
      }
    },
    async printEftAchReport() {
      const effectiveDateForAchReport = localStorage.getItem('effectiveDate') || '';

      const { jwt } = await this.reAuth();
      const getcriteria = {
        ...this.criteriaState,
      };
      const encodedCriteria = encodeURIComponent(JSON.stringify(getcriteria));
      if (this.criteriaState.remitWarrantDate) {
        const params = [
          `token=${jwt}`,
          `filters=${encodedCriteria}`,
          `effectiveDate=${effectiveDateForAchReport}`,
        ];
        if (this.devSetting && this.devSetting.isTestEnvironment) {
          params.push('isTestCafe=1');
        }
        const queryString = generateQueryString(params);
        const url = `${backendRest.defaults.baseURL}/remit/eft-ach-summary${queryString}`;
        window.open(url, '_blank');
      } else {
        this.flashWarn('Please select warrant date to print EFT/ACH Report!');
      }
    },
    async exportUrl() {
      const { jwt } = await this.reAuth();
      const { remitWarrantDate } = this.criteriaState;
      const effectiveDate = this.effectiveDateVal;
      const backendURL = backendRest.defaults.baseURL;
      const url = `${backendURL}/transmap/exportCustomFixedWidth?fileHeaders=true&remitWarrantDate=${remitWarrantDate}&effectiveDate=${effectiveDate}&program=TAX&token=${jwt}`; if (url && url !== '' && !url.match(/NaN/) && !url.match(/\/$/)) {
        window.open(url, '_blank');
      }
    },
    isFiltersAvailable() {
      return (this.criteriaState.remitWarrantDate);
    },
    async achExport() {
      localStorage.setItem('effectiveDate', this.effectiveDateVal);
      await (this.exportUrl({ formatFile: 'achFile.txt' }) || '');
      this.openDailog = false;
    },
  },
};
</script>
<style scoped>
.flex-btns {
  display: flex;
  flex-direction: row;
}
.apportionment-btns {
  /* width: fit-content; */
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    gap: 2px;
}
.flex-row {
  display: flex;
  justify-content: center;
}
</style>
